import React from 'react'
import { CarouselProvider, Slider as PureSlider, Slide, ButtonBack, ButtonNext, DotGroup, Dot, CarouselContext } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'

import useScreenSize from '../../../hocs/useScreenSize'
import ArrowHead from '../../../assets/icons/arrow-head-right.svg?react'
import './styles.css'

type Props = {
  children: Array<React.ReactElement>
  slides2xl?: number
  slidesXl?: number
  slidesLg?: number
  slidesMd?: number
  slidesSm?: number
  slidesXs?: number
}
const Slider: React.FC<Props> = ({
  children,
  slides2xl = 5.3, slidesXl = 5.3, slidesLg = 5.3, slidesMd = 4.3, slidesSm = 3.3, slidesXs = 2.3,
}) => {
  const screenSize = useScreenSize()
  let slidesToShow = 0
  if(screenSize.is2xl) { slidesToShow = slides2xl }
  else if(screenSize.isXl) { slidesToShow = slidesXl }
  else if(screenSize.isLg) { slidesToShow = slidesLg }
  else if(screenSize.isMd) { slidesToShow = slidesMd }
  else if(screenSize.isSm) { slidesToShow = slidesSm }
  else if(screenSize.isXs) { slidesToShow = slidesXs }

  const getDotsAmount = React.useCallback(() => {
    const totalCards = children.length
    const fullyVisibleCards = Math.floor(slidesToShow)
    if(totalCards < fullyVisibleCards) {
      return 0
    }
    return totalCards - fullyVisibleCards + 1
  }, [slidesToShow, children.length])

  return (
    <div className='relative'>
      <CarouselProvider
        naturalSlideWidth={102}
        naturalSlideHeight={1}
        totalSlides={children.length}
        visibleSlides={slidesToShow}
        isIntrinsicHeight
        infinite
        touchEnabled={!screenSize.isLg}
        dragEnabled={!screenSize.isLg}
      >
        <PureSlider className='pb-3'>
          {children.map((child, index) => (
            <Slide key={index} index={index}><div className='mx-2 h-full'>{child}</div></Slide>
          ))}
        </PureSlider>
        <DotGroup className='text-center mt-4' renderDots={() => {}} showAsSelectedForCurrentSlideOnly>
          {new Array(getDotsAmount()).fill(1).map((_, index) => (
            <Dot key={index} slide={index} disabled={false} className='slider-dot w-3 h-3 bg-deep-green rounded-full m-1' />
          ))}
        </DotGroup>
        {children.length > slidesToShow ?  <ArrowButtons /> : null}
      </CarouselProvider>
    </div>
  )
}

const ArrowButtons = () => {
  const carouselContext =  React.useContext(CarouselContext)
  const [showLeftArrow, setShowLeftArrow] = React.useState(false)
  React.useEffect(() => {
    function onChange() {
      setShowLeftArrow(carouselContext.state.currentSlide !== 0)
    }
    carouselContext.subscribe(onChange)
    return () => carouselContext.unsubscribe(onChange)
  }, [carouselContext])
  const arrowClasses = 'bg-white opacity-85 p-3 rounded-full hover:bg-soft-green'
  const wrapperArrowClasses = 'absolute bottom-1/2 hidden lg:block '
  return (
    <>
      {showLeftArrow && (
        <div className={`${wrapperArrowClasses} left-0`}>
          <ButtonBack className={`${arrowClasses} -translate-x-8 rotate-180`}><ArrowHead className='stroke-deep-green w-7 h-7' /></ButtonBack>
        </div>
      )}
      <div className={`${wrapperArrowClasses} right-0`}>
        <ButtonNext className={`${arrowClasses} translate-x-8`}><ArrowHead className='stroke-deep-green w-7 h-7' /></ButtonNext>
      </div>
    </>
  )
}

export default Slider
